module.exports = __webpack_public_path__ + "static/media/google-scholar-brands-solid.598e459f.svg";